import resolveConfig from 'tailwindcss/resolveConfig';

import tailwindConfig from 'tailwind-config';

const { theme } = resolveConfig(tailwindConfig);

const customCompsetPalette = [
  theme.colors.maya['500'],
  theme.colors.unicorn['500'],
  theme.colors.amethyst['500'],
  theme.colors.turkish['500'],
  theme.colors.cardinal['500'],
  theme.colors.peachy['500'],
  theme.colors.pottery['500'],
  theme.colors.egg['500'],
  theme.colors.butano['500'],
];

export default customCompsetPalette;
